<template>
    <div>
        <div style="position: relative; height: 100%;">
            <img :src="visual" class="intro_img" @load="onLoad">
            <div class="typewriter_title_box">
                <div class="typewriter_title_box_wrapper">
                    <div class="title_line1_wrapper">
                    <span
                    v-for="char in titles.line1"
                    :key="char.id"
                    class="title_line1"
                    :class="{'st0': char.id % 2 === 0, 'st1': char.id % 2 === 1}">{{char.content}}</span>
                    </div>
                    <div class="title_line2_wrapper">
                    <span
                    v-for="char in titles.line2"
                    :key="char.id"
                    class="title_line2"
                    :class="{'st0': char.id % 2 === 0, 'st1': char.id % 2 === 1}">{{char.content}}</span>
                    </div>
                    <div class="title_line3_wrapper">
                    <span
                    v-for="char in titles.line3"
                    :key="char.id"
                    class="title_line3"
                    :class="{'st1': char.id % 2 === 0, 'st0': char.id % 2 === 1}">{{char.content}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-center mt-15 mb-2 mb-sm-0">
            <div class="d-flex justify-center intro_explain_box">
                <p class="text-center intro_title mb-5">好きなテンプレートを選んで、<br class="smart_only">オリジナル報告画像を作ろう！</p>
                <p class="text-center intro_caution mb-5">※ログインや新規登録は必要ありません。</p>
                <p class="text-center intro_term_text mb-0">公開期間 <span class="lifullFontBold">2021/3/19</span><span class="intro_yu_gothic_little">(金)</span>〜<span class="lifullFontBold">2021/3/31</span><span class="intro_yu_gothic_little">(水)</span></p>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import visualPc from '../assets/kv_pc.jpg';
import visualSp from '../assets/kv_sp.jpg';
export default {
    data(){
        return{
            visual: "",
            visualPc,
            visualSp,
            titles: {
                line1: [
                    {id: 0, content: "新"},
                    {id: 1, content: "生"},
                    {id: 2, content: "活"},
                ],
                line2: [
                    {id: 0, content: "【"},
                    {id: 1, content: "ご"},
                    {id: 2, content: "報"},
                    {id: 3, content: "告"},
                    {id: 4, content: "】"},
                ],
                line3: [
                    {id: 0, content: "ジ"},
                    {id: 1, content: "ェ"},
                    {id: 2, content: "ネ"},
                    {id: 3, content: "レ"},
                    {id: 4, content: "ー"},
                    {id: 5, content: "タ"},
                    {id: 6, content: "ー"},
                ],
            }
        }
    },
    computed: {
    },
    watch: {
    },
    methods: {
        onResize(event) {
            this.setVisual();
        },
        setVisual(){
            let wid = window.innerWidth;
            let breakPoint = 600;
            if (wid < breakPoint){
                this.visual = this.visualSp;
            }else if(this.visual !== this.visualPc){
                this.visual = this.visualPc;
            }
        },
        onLoad(){
            this.$store.state.isLoadingKV = false;
        }
    },
    mounted(){
        this.setVisual();
        window.addEventListener('resize', this.onResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    }
}
</script>

<style scoped>
.intro_img{
    width: 100%;
}
@media all and (-ms-high-contrast: none) {
    .intro_img{
        width: 100vw;
    }
}
.intro_explain_box{
    flex-direction: column;
    max-width: 958px;
    margin: 0 12px;
    padding:30px 0px;
    width: 100%;
    background-color: #FFBC34;
    border-radius: 12px;
}
.intro_title{
    font-weight: bold;
    color: #ed6103;
    font-size: 24px;
}
.intro_caution{
    font-weight: bold;
    color: black;
    font-size: 14px;
}
.intro_term_text{
    color: black;
    font-weight: bold;
    font-size: 20px;
}
.intro_yu_gothic_little{
    font-size: 14px;
}
@media only screen and (max-width: 599px){
    .intro_title{
        font-size: 20px;
    }
    .intro_caution{
        font-size: 12px;
    }
}
@media only screen and (max-width: 414px){
}
</style>